export default "__VITE_ASSET__DARvgcWt__"